"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToProjects = exports.deleteProjectRealTime = exports.editProjectRealTime = exports.addProjectRealTime = exports.editProject = exports.deleteProject = exports.addProject = exports.fetchProjectById = exports.fetchAllProjects = exports.fetchProjectsInBatches = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var supabaseClient_1 = require("../../supabaseClient"); // Adjust the import path as needed
var initialState = {
    data: [],
    status: "idle",
    project: {},
    error: null,
    globalProjectsData: {},
    loaded: false,
};
// Fetch all projects in batches
exports.fetchProjectsInBatches = (0, toolkit_1.createAsyncThunk)("projects/fetchProjectsInBatches", function (_, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("projects_warehouses")
                        .select("*")];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
exports.fetchAllProjects = (0, toolkit_1.createAsyncThunk)("allocation/fetchAllProjects", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase.from("projects_warehouses").select()];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, data];
        }
    });
}); });
// Fetch project by id
exports.fetchProjectById = (0, toolkit_1.createAsyncThunk)("orders/fetchProjectById", function (projectId, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("projects_warehouses")
                    .select("*")
                    .eq("id", projectId)
                    .single()];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, data];
        }
    });
}); });
// Add a new project
exports.addProject = (0, toolkit_1.createAsyncThunk)("projects/addProject", function (newProject, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, insertData, insertError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("projects_warehouses")
                    .insert(newProject)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), insertData = _a.data, insertError = _a.error;
                if (insertError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(insertError.message)];
                }
                return [2 /*return*/, insertData];
        }
    });
}); });
// Delete a project
exports.deleteProject = (0, toolkit_1.createAsyncThunk)("projects/deleteProject", function (id, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("projects_warehouses")
                    .delete()
                    .eq("id", id)];
            case 1:
                error = (_a.sent()).error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, id];
        }
    });
}); });
// Edit a project
exports.editProject = (0, toolkit_1.createAsyncThunk)("projects/editProject", function (updatedProject, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, updateData, updateError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("projects_warehouses")
                    .update(updatedProject)
                    .eq("id", updatedProject.id)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), updateData = _a.data, updateError = _a.error;
                if (updateError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(updateError.message)];
                }
                return [2 /*return*/, updateData];
        }
    });
}); });
// Real-time actions
var addProjectRealTime = function (newProject) { return ({
    type: "projects/addProjectRealTime",
    payload: newProject,
}); };
exports.addProjectRealTime = addProjectRealTime;
var editProjectRealTime = function (updatedProject) { return ({
    type: "projects/editProjectRealTime",
    payload: updatedProject,
}); };
exports.editProjectRealTime = editProjectRealTime;
var deleteProjectRealTime = function (id) { return ({
    type: "projects/deleteProjectRealTime",
    payload: id,
}); };
exports.deleteProjectRealTime = deleteProjectRealTime;
// Slice definition
var projectsSlice = (0, toolkit_1.createSlice)({
    name: "projects",
    initialState: initialState,
    reducers: {
        addProjectRealTime: function (state, action) {
            var exists = state.data.some(function (project) { return project.id === action.payload.id; });
            if (!exists) {
                state.data.push(action.payload);
            }
            state.error = null;
        },
        editProjectRealTime: function (state, action) {
            var _a;
            var updatedProject = action.payload;
            state.globalProjectsData[(_a = updatedProject.id) !== null && _a !== void 0 ? _a : ""] = updatedProject;
            console.log({ updatedProject: updatedProject });
            var index = state.data.findIndex(function (project) { return project.id === action.payload.id; });
            if (index !== -1) {
                var isDifferent = JSON.stringify(state.data[index]) !== JSON.stringify(action.payload);
                if (isDifferent) {
                    state.data[index] = action.payload;
                }
            }
            state.error = null;
        },
        deleteProjectRealTime: function (state, action) {
            var exists = state.data.some(function (project) { return project.id === action.payload; });
            if (exists) {
                state.data = state.data.filter(function (project) { return project.id !== action.payload; });
            }
            state.error = null;
        },
    },
    extraReducers: function (builder) {
        builder
            .addCase(exports.fetchAllProjects.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchAllProjects.fulfilled, function (state, action) {
            state.status = "succeeded";
            state.data = action.payload;
            state.error = null;
        })
            .addCase(exports.fetchAllProjects.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch allocations.";
        })
            .addCase(exports.fetchProjectById.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchProjectById.fulfilled, function (state, action) {
            state.status = "succeeded";
            state.project = action.payload;
            state.error = null;
        })
            .addCase(exports.fetchProjectById.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch allocations.";
        })
            // Handle fetchProjectsInBatches
            .addCase(exports.fetchProjectsInBatches.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchProjectsInBatches.fulfilled, function (state, action) {
            state.loaded = true;
            action.payload.forEach(function (project) {
                var _a;
                state.globalProjectsData[(_a = project.id) !== null && _a !== void 0 ? _a : ""] = project;
            });
        })
            .addCase(exports.fetchProjectsInBatches.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch projects.";
        })
            // Handle addProject
            .addCase(exports.addProject.fulfilled, function (state, action) {
            state.data.push(action.payload);
            state.error = null;
        })
            .addCase(exports.addProject.rejected, function (state, action) {
            state.error = action.payload || "Failed to add project.";
        })
            // Handle deleteProject
            .addCase(exports.deleteProject.fulfilled, function (state, action) {
            state.data = state.data.filter(function (project) { return project.id !== action.payload; });
            state.error = null;
        })
            .addCase(exports.deleteProject.rejected, function (state, action) {
            state.error = action.payload || "Failed to delete project.";
        })
            // Handle editProject
            .addCase(exports.editProject.fulfilled, function (state, action) {
            var index = state.data.findIndex(function (project) { return project.id === action.payload.id; });
            if (index !== -1) {
                state.data[index] = action.payload;
            }
            state.error = null;
        })
            .addCase(exports.editProject.rejected, function (state, action) {
            state.error = action.payload || "Failed to edit project.";
        });
    },
});
// Real-time subscription function
var subscribeToProjects = function (dispatch) {
    var subscription = supabaseClient_1.supabase
        .channel("public:projects")
        .on("postgres_changes", { event: "*", schema: "public", table: "projects_warehouses" }, function (payload) {
        var _a;
        var newRecord = payload.new;
        var oldRecord = payload.old;
        console.log({ newRecord: newRecord });
        switch (payload.eventType) {
            case "INSERT":
                dispatch((0, exports.addProjectRealTime)(newRecord));
                break;
            case "UPDATE":
                dispatch((0, exports.editProjectRealTime)(newRecord));
                break;
            case "DELETE":
                dispatch((0, exports.deleteProjectRealTime)((_a = oldRecord.id) !== null && _a !== void 0 ? _a : ""));
                break;
            default:
                break;
        }
    })
        .subscribe();
    return function () {
        subscription.unsubscribe();
    };
};
exports.subscribeToProjects = subscribeToProjects;
exports.default = projectsSlice.reducer;
